export const UPLOAD_APK = "UPLOAD_APK";
export const FETCH_UPLOAD_APK = "FETCH_UPLOAD_APK";
export const LIST_UPLOAD_APK = "LIST_UPLOAD_APK";
export const MODIFY_UPLOAD_APK = "MODIFY_UPLOAD_APK";
export const CLEAR_UPLOAD_APK = "CLEAR_UPLOAD_APK";

export const FETCH_USER_CONFIG = "FETCH_USER_CONFIG";
export const LIST_USER_CONFIG = "LIST_USER_CONFIG";
export const MODIFY_USER_CONFIG = "MODIFY_USER_CONFIG";
export const CLEAR_USER_CONFIG = "CLEAR_USER_CONFIG";
export const ERROR_USER_CONFIG = "ERROR_USER_CONFIG";

export const FETCH_ACTIVITY_LOG = "FETCH_ACTIVITY_LOG";
export const LIST_ACTIVITY_LOG = "LIST_ACTIVITY_LOG";
export const CLEAR_ACTIVITY_LOG = "CLEAR_ACTIVITY_LOG";
export const LIST_ACTIVITY_LOG_MODULES = "LIST_ACTIVITY_LOG_MODULES";
